import { createContext } from 'react';

import type { FilterFieldLoggerContextProps } from './FilterFieldContext.types.js';

/** @internal */
export const FilterFieldLoggerContext =
  createContext<FilterFieldLoggerContextProps>({});
